
@if(true){
    <div class="container-fluid">
        <div class="page-heading d-flex align-items-center justify-content-between my-4 px-2">
            {{ pageHeader }}
            <button class="btn btn-outline-primary" title="Go Back" (click)="goBack()">
                <i class="fa fa-arrow-left"></i> Back
            </button>
        </div>
        <form  [formGroup]="addFormFinalVedict" (ngSubmit)="onFinalVerdictSubmit(addFormFinalVedict.value);">  
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="refno" class="form-label">{{RefNo}}</label>
                                <input readonly type="text" class="form-control" formControlName="refno" placeholder="Case Number" name="refno" id="refno" />
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="Jurisdiction" class="form-label">{{CaptionJurisdiction}} <span class="text-danger">*</span> </label>
                                <ng-select
                                    [items]="Jurisdiction"
                                    bindLabel="MainDescr"
                                    bindValue="hdID"
                                    formControlName="Jurisdiction"
                                    [clearable]="false"
                                    placeholder="Select Jurisdiction">
                                    <ng-option [value]="'0'">Not Selected</ng-option>
                                </ng-select>
                                @if (f.Jurisdiction.touched && f.Jurisdiction.invalid) {
                                    @if (f.Jurisdiction.errors.required) {
                                        <span class="text-danger">Jurisdiction is required.</span>
                                    }
                                }
                            </div>
                        </div>
                    </div>
            
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label class="form-label">Filing Party</label>
                                    @for (feFD of FetchExistingFillingParty; track feFD; let i = $index) {
                                        <div class="col-sm-12 ">
                                            <div class="col-sm-12">
                                                <b class="col-sm-5">{{i + 1}})</b>
                                                <span class="col-sm-6">{{feFD.Name}}</span>
                                            </div>
                                        </div>
                                    }
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label class="form-label">Opposite Party</label>
                                    @for (feOP of FetchExistingOppositeParty; track feOP; let i = $index) {
                                        <div class="col-sm-12 ">
                                            <div class="col-sm-12">
                                                <b class="col-sm-5">{{i + 1}})</b>
                                                <span class="col-sm-6">{{feOP.Name}}</span>
                                            </div>
                                        </div>
                                    }
                            </div>
                        </div>
                    </div>
            
                    <div class="row">
                        <div class="col-12 col-md-4">
                            <div class="form-group">
                                <label for="State" class="form-label">State <span style="color:red;">*</span> </label>
                                <ng-select
                                    [items]="State"
                                    bindLabel="MainDescr"
                                    bindValue="hdID"
                                    formControlName="State"
                                    (change)="onStateSelect($event)"
                                    [clearable]="false"
                                    placeholder="Not Selected">
                                    <ng-option [value]="'0'">Not Selected</ng-option>
                                </ng-select>
                                @if (f.State.touched && f.State.invalid) {
                                    @if (f.State.errors.required) {
                                        <span class="text-danger">State is required.</span>
                                    }
                                }
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group">
                                <label for="City" class="form-label">City <span style="color:red;">*</span> </label>
                                <ng-select
                                    [items]="City"
                                    bindLabel="MainDescr"
                                    bindValue="hdID"
                                    formControlName="City"
                                    (change)="onCitySelect($event)"
                                    [clearable]="false"
                                    placeholder="Not Selected">
                                    <ng-option [value]="'0'">Not Selected</ng-option>
                                </ng-select>
                                @if (f.City.touched && f.City.invalid) {
                                    @if (f.City.errors.required) {
                                        <span class="text-danger">City is required.</span>
                                    }
                                }
                            </div>
                        </div>
            
                        <div class="col-12 col-md-4">
                            <div class="form-group">
                                <label for="Category" class="form-label">Category <span style="color:red;">*</span> </label>
                                <ng-select
                                    [items]="Category"
                                    bindLabel="MainDescr"
                                    bindValue="hdID"
                                    formControlName="Category"
                                    (change)="onCategorySelect($event)"
                                    [clearable]="false"
                                    placeholder="Not Selected">
                                    <ng-option [value]="'0'">Not Selected</ng-option>
                                </ng-select>
                                @if (f.Category.touched && f.Category.invalid) {
                                    @if (f.Category.errors.required) {
                                        <span class="text-danger">Category is required.</span>
                                    }
                                }
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group">
                                <label for="SubCategory" class="form-label">Sub Category <span style="color:red;">*</span> </label>
                                <ng-select
                                    [items]="SubCategory"
                                    bindLabel="MainDescr"
                                    bindValue="hdID"
                                    formControlName="SubCategory"
                                    [clearable]="false"
                                    placeholder="Not Selected">
                                    <ng-option [value]="'0'">Not Selected</ng-option>
                                </ng-select>
                                @if (f.SubCategory.touched && f.SubCategory.invalid) {
                                    @if (f.SubCategory.errors.required) {
                                        <span class="text-danger">Sub Category is required.</span>
                                    }
                                }
                            </div>
                        </div>
            
                        <div class="col-12 col-md-4">
                            <div class="form-group">
                                <label for="browseFiles" class="form-label">Final Order <span style="color:red;">*</span> </label>
                                <input type='file' formControlName="browseFiles" (change)="onSelectFile($event)" multiple>
                                @if (f.browseFiles.touched && f.browseFiles.invalid) {
                                    @if (f.browseFiles.errors.required) {
                                        <span class="text-danger">Final Order is required.</span>
                                    }
                                }
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group">
                                <label for="Amount" class="form-label">Amount <span style="color:red;">*</span> </label>
                                <input type="number" class="form-control" formControlName="Amount" placeholder="Amount" required="required" />
                                @if (f.Amount.touched && f.Amount.invalid) {
                                    @if (f.Amount.errors.required) {
                                        <span class="text-danger">Amount is required.</span>
                                    }
                                }
                            </div>
                        </div>
            
                        <div class="col-12 col-md-4">
                            <div class="form-group">
                                <label for="Decision" class="form-label">Decision <span style="color:red;">*</span></label>
                                <ng-select
                                    [items]="[
                                        { label: 'Not Selected', value: '0' },
                                        { label: 'In Our Favour', value: '1' },
                                        { label: 'Against US', value: '2' }
                                    ]"
                                    bindLabel="label"
                                    bindValue="value"
                                    formControlName="Decision"
                                    [clearable]="false"
                                    multiple="true"
                                    placeholder="Select Decision">
                                </ng-select>
                                @if (f.Decision.touched && f.Decision.invalid) {
                                    @if (f.Decision.errors.required) {
                                        <span class="text-danger">Decision is required.</span>
                                    }
                                }
                            </div>
                        </div>
                        <div class="col-12 col-md-8">
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-12 col-md-6 mb-2 mb-md-0">
                                        <label class="form-label">Time Period from <span style="color:red;">*</span> </label>
                                        <mat-form-field class="fullwidth w-100" appearance="outline">
                                            <input matInput [min]="minDate" formControlName="DateofFinalvedictFromTime"
                                                [max]="maxDate" [matDatepicker]="picker" placeholder="From Date">
                                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                            <mat-datepicker #picker></mat-datepicker>
                                        </mat-form-field>
                                        @if (f.DateofFinalvedictFromTime.touched && f.DateofFinalvedictFromTime.invalid) {
                                            @if (f.DateofFinalvedictFromTime.errors.required) {
                                                <span class="text-danger">Time Period from is required.</span>
                                            }
                                        }
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <label class="form-label">Time Period to <span style="color:red;">*</span> </label>
                                        <mat-form-field class="fullwidth w-100" appearance="outline">
                                            <input matInput [min]="minDate" formControlName="DateofFinalvedictToTime"
                                                [max]="maxDate" [matDatepicker]="picker1" placeholder="To Date">
                                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                            <mat-datepicker #picker1></mat-datepicker>
                                        </mat-form-field>
                                        @if (f.DateofFinalvedictToTime.touched && f.DateofFinalvedictToTime.invalid) {
                                            @if (f.DateofFinalvedictToTime.errors.required) {
                                                <span class="text-danger">Time Period to is required.</span>
                                            }
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
            
                        <div class="col-12 col-md-4">
                            <div class="form-group">
                                <label for="JudgementsImplications" class="form-label">Judgements Implications <span style="color:red;">*</span> </label>
                                <ng-select
                                    [items]="dropdownListJudgements"
                                    bindLabel="MainDescr"
                                    bindValue="hdID"
                                    formControlName="JudgementsImplications"
                                    [multiple]="true"
                                    [closeOnSelect]="false"
                                    placeholder="Select Judgements Implications"
                                    (change)="onManagerDecisionSelectJudgements($event)">
                                </ng-select>
                                @if (f.JudgementsImplications.touched && f.JudgementsImplications.invalid) {
                                    @if (f.JudgementsImplications.errors.required) {
                                        <span class="text-danger">Judgements Implications is required.</span>
                                    }
                                }
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group">
                                <label for="Remarks" class="form-label">Remarks</label>
                                <textarea type="text" formControlName="Remarks" class="form-control" rows="3"></textarea>
                            </div>
                        </div>
            
                        <div class="col-12 col-md-4">
                            <div class="form-group">
                                <label for="ManagementDecision" class="form-label">Management Decision</label>
                                    <ng-select
                                    [items]="dropdownList"
                                    bindLabel="MainDescr"       
                                    bindValue="hdID"
                                    placeholder="Select Management Decision"
                                    [closeOnSelect]="false"
                                    formControlName="ManagementDecision"
                                    [multiple]="true"
                                    (add)="onManagerDecisionAdd($event)"
                                    (remove)="onManagerDecisionRemove($event)">
                                    </ng-select>
                                @if (f.ManagementDecision.touched && f.ManagementDecision.invalid) {
                                    @if (f.ManagementDecision.errors.required) {
                                        <span class="text-danger">Management Decision is required.</span>
                                    }
                                }
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            @if (RequestFromUploadFile == '7') {
                                <label class="form-label">Uploaded Files</label>
                                <div class="border rounded p-2">
                                    <table class="table table-sm">
                                        <thead>
                                            <tr>
                                                <th>S.No.</th>
                                                <th>Files</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            @for (fsD of factsheetDetail; track fsD; let i = $index) {
                                                <tr>
                                                    <td align="center">{{i + 1}}</td>
                                                    <td>
                                                        @for (fsDFile of fsD.attachment; track fsDFile; let j = $index) {
                                                            <div>
                                                                <a href="{{DownloadURL}}{{fsDFile.DownloadPath}}">{{fsDFile.DisplayName}}</a>
                                                            </div>
                                                        }
                                                    </td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            }
                        </div>
                    </div>
            
                    @if (PaymentofPenaltyRequestFrom == '1') {
                        <div class="border-top pt-3 mt-3">
                            <h4 class="mb-4">Payment of Penalty</h4>
                            <div class="row mb-3">
                                <div class="col-12 col-md-4">
                                    <div class="form-group">
                                        <label for="PaymentAmount" class="form-label">Amount <span style="color:red;">*</span> </label>
                                        <input type="number" class="form-control" formControlName="PaymentAmount" placeholder="Amount" required="required" />
                                        @if (f.PaymentAmount.touched && f.PaymentAmount.invalid) {
                                            @if (f.PaymentAmount.errors.required) {
                                                <span class="text-danger">Amount is required.</span>
                                            }
                                        }
                                    </div>
                                </div>
                                <div class="col-12 col-md-4">
                                    <div class="form-group">
                                        <label for="PaymentResponsiblePerson" class="form-label">Responsible Person <span style="color:red;">*</span> </label>
                                        <ng-select
                                            [items]="PaymentResponsiblePerson"
                                            bindLabel="USERNAME"
                                            bindValue="ID"
                                            formControlName="PaymentResponsiblePerson"
                                            [clearable]="false"
                                            placeholder="Not Selected">
                                            <ng-option [value]="'0'">Not Selected</ng-option>
                                        </ng-select>
                                        @if (f.PaymentResponsiblePerson.touched && f.PaymentResponsiblePerson.invalid) {
                                            @if (f.PaymentResponsiblePerson.errors.required) {
                                                <span class="text-danger">Responsible Person is required.</span>
                                            }
                                        }
                                    </div>
                                </div>

                                <div class="col-12 col-md-4">
                                    <div class="form-group">
                                        <label for="Paymenttomadeinfavourof" class="form-label">Payment to made in favour of <span style="color:red;">*</span> </label>
                                        <input type="text" class="form-control" formControlName="Paymenttomadeinfavourof" placeholder="Payment to made in favour of" required="required" />
                                        @if (f.Paymenttomadeinfavourof.touched && f.Paymenttomadeinfavourof.invalid) {
                                            @if (f.Paymenttomadeinfavourof.errors.required) {
                                                <span class="text-danger">Payment to made in favour of is required.</span>
                                            }
                                        }
                                    </div>
                                </div>
                                <div class="col-12 col-md-4">
                                    <div class="form-group">
                                        <label for="PaymentRemarks" class="form-label">Remarks <span style="color:red;">*</span> </label>
                                        <textarea type="text" formControlName="PaymentRemarks" class="form-control" rows="2"></textarea>
                                        @if (f.PaymentRemarks.touched && f.PaymentRemarks.invalid) {
                                            @if (f.PaymentRemarks.errors.required) {
                                                <span class="text-danger">Remarks is required.</span>
                                            }
                                        }
                                    </div>
                                </div>

                                <div class="col-12 col-md-8">
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-12 col-md-6 mb-2 mb-md-0">
                                                <label class="form-label">Time Period in <span style="color:red;">*</span> </label>
                                                <mat-form-field class="fullwidth w-100" appearance="outline" >
                                                    <input matInput [min]="minDate" formControlName="DateofFinalVedictPaymentFromTime"
                                                        [max]="maxDate" [matDatepicker]="picker4" placeholder="From Date">
                                                    <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker4></mat-datepicker>
                                                </mat-form-field>
                                                @if (f.DateofFinalVedictPaymentFromTime.touched && f.DateofFinalVedictPaymentFromTime.invalid) {
                                                    @if (f.DateofFinalVedictPaymentFromTime.errors.required) {
                                                        <span class="text-danger">Time Period in is required.</span>
                                                    }
                                                }
                                            </div>
                                            <div class="col-12 col-md-6">
                                                <label class="form-label">Time Period out <span style="color:red;">*</span> </label>
                                                <mat-form-field class="fullwidth w-100" appearance="outline">
                                                    <input matInput [min]="minDate" formControlName="DateofFinalVedictPaymentToTime"
                                                        [max]="maxDate" [matDatepicker]="picker5" placeholder="To Date">
                                                    <mat-datepicker-toggle matSuffix [for]="picker5"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker5></mat-datepicker>
                                                </mat-form-field>
                                                @if (f.DateofFinalVedictPaymentToTime.touched && f.DateofFinalVedictPaymentToTime.invalid) {
                                                    @if (f.DateofFinalVedictPaymentToTime.errors.required) {
                                                        <span class="text-danger">Time Period out is required.</span>
                                                    }
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
            
                    @if (RecoveryofAmountRequestFrom == '2') {
                        <div class="border-top pt-3 mt-3">
                            <h4 class="mb-4">Recovery of Amount</h4>
                            <div class="row mb-3">
                                <div class="col-12 col-md-6">
                                    <div class="form-group">
                                        <label for="RecoverAmount" class="form-label">Amount</label>
                                        <input type="number" class="form-control" formControlName="RecoverAmount" placeholder="Amount" required="required" />
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="form-group">
                                        <label for="RecoveryResponsiblePerson" class="form-label">Responsible Person</label>
                                        <ng-select
                                            [items]="RecoveryResponsiblePerson"
                                            bindLabel="USERNAME"
                                            bindValue="ID"
                                            formControlName="RecoveryResponsiblePerson"
                                            [clearable]="false"
                                            placeholder="Not Selected">
                                            <ng-option [value]="'0'">Not Selected</ng-option>
                                        </ng-select>
                                    </div>
                                </div>

                                <div class="col-12 col-md-6">
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-12 col-md-6 mb-2 mb-md-0">
                                                <label class="form-label">Time Period in</label>
                                                <mat-form-field class="fullwidth w-100" appearance="outline" >
                                                    <input matInput [min]="minDate" formControlName="DateofFinalVedictRecoveryFromTime"
                                                        [max]="maxDate" [matDatepicker]="picker6" placeholder="From Date">
                                                    <mat-datepicker-toggle matSuffix [for]="picker6"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker6></mat-datepicker>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-12 col-md-6">
                                                <label class="form-label">Time Period out</label>
                                                <mat-form-field class="fullwidth w-100" appearance="outline" >
                                                    <input matInput [min]="minDate" formControlName="DateofFinalVedictRecoveryToTime"
                                                        [max]="maxDate" [matDatepicker]="picker7" placeholder="To Date">
                                                    <mat-datepicker-toggle matSuffix [for]="picker7"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker7></mat-datepicker>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="form-group">
                                        <label for="RecoveryRemarks" class="form-label">Remarks</label>
                                        <textarea type="text" formControlName="RecoveryRemarks" class="form-control" rows="2"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
            
                    @if (ComplianceofComplyRequestFrom == '3') {
                        <div class="border-top pt-3 mt-3">
                            <h4 class="mb-4">Comply with Compliance</h4>
                            <div class="row mb-3">
                                <div class="col-12 col-md-6">
                                    <div class="form-group">
                                        <label for="TypeofCompliance" class="form-label">Type of Compliance</label>
                                        <input type="text" class="form-control" formControlName="TypeofCompliance" placeholder="Type of Compliance" required="required" />
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="form-group">
                                        <label for="ComplianceResponsiblePerson" class="form-label">Responsible Person</label>
                                        <ng-select
                                            [items]="ComplianceResponsiblePerson"
                                            bindLabel="USERNAME"
                                            bindValue="ID"
                                            formControlName="ComplianceResponsiblePerson"
                                            [clearable]="false"
                                            placeholder="Not Selected">
                                            <ng-option [value]="'0'">Not Selected</ng-option>
                                        </ng-select>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="row mb-3">
                                <div class="col-12 col-md-6">
                                    <div class="form-group">
                                        <label class="form-label">Time Period</label>
                                        <div class="row">
                                            <div class="col-12 col-md-6 mb-2 mb-md-0">
                                                <mat-form-field class="fullwidth w-100" appearance="outline">
                                                    <input matInput [min]="minDate" formControlName="DateofFinalVedictComplianceFromTime"
                                                        [max]="maxDate" [matDatepicker]="picker8" placeholder="From Date">
                                                    <mat-datepicker-toggle matSuffix [for]="picker8"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker8></mat-datepicker>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-12 col-md-6">
                                                <mat-form-field class="fullwidth w-100" appearance="outline">
                                                    <input matInput [min]="minDate" formControlName="DateofFinalVedictComplianceToTime"
                                                        [max]="maxDate" [matDatepicker]="picker9" placeholder="To Date">
                                                    <mat-datepicker-toggle matSuffix [for]="picker9"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker9></mat-datepicker>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="form-group">
                                        <label for="ComplianceRemarks" class="form-label">Remarks</label>
                                        <textarea type="text" formControlName="ComplianceRemarks" class="form-control" rows="2"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
        
                </div>
            </div>      
        
                <div class="d-flex align-items-center justify-content-center my-5">
                    @if (buttonSubmitFinalVerdict == '1') {
                        <button class="btn btn-primary submit-btn small" 
                                type="submit" >
                            Submit
                        </button>
                    }
                    @if (buttonSubmitFinalVerdict == '2') {
                        <button class="btn btn-primary submit-btn small" 
                                type="submit" >
                            Update
                        </button>
                    }
                </div>
        </form>
    </div>
}
 @else  {
    <!-- <my-content placeholder="navigation">
    
        <div>&nbsp;</div>
            <div class="titlebar d-flex align-items-center justify-content-center">
                <div class="titlebar-text">
                    <i class="fa fa-gavel text-primary"></i>
                    <span class="ml-2 page-title">{{pageHeader}}</span>
                </div>
            </div>
        <div>&nbsp;</div>
        <div class=" col-sm-12">
            <form #AddFinalVerdict="ngForm" [formGroup]="addFormFinalVedict"
                (ngSubmit)="onFinalVerdictSubmit(AddFinalVerdict.value);">
                <fieldset style="margin-left: 4%; margin-right: 4%; border: 1px solid #ccc;">
                    <table style="margin-top: 10px; margin-right: 15px;">
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
                            <td width="15%">{{this.RefNo}}</td>
                            <td width="35%">
                                <div class="col-sm-10">
                                    <input readonly type="text" class="form-control" formControlName="refno"
                                        placeholder="Case Number" ngMode value="" name="refno" id="refno" />
                                </div>
                            </td>
                            <td width="15%">{{CaptionJurisdiction}}</td>
                            <td width="35%">
    
                                <ng-select
                                  [items]="Jurisdiction"
                                  bindLabel="MainDescr"
                                  bindValue="hdID"
                                  formControlName="Jurisdiction"
                                  [clearable]="false"
                                  placeholder="Not Selected">
                                  <ng-option [value]="'0'">Not Selected</ng-option>
                                </ng-select>
    
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
                            <td width="15%">Filling Party</td>
                            <td width="35%">
                                <div class="col-sm-12 paddingless"
                                    *ngFor="let feFD of FetchExistingFillingParty; let i=index ">
                                    <div class="col-sm-12">
                                        <b class="col-sm-5"> {{i+1}} )
                                        </b> <span class="col-sm-6">{{feFD.Name}}
                                        </span>
    
    
                                    </div>
                                    <div class="col-sm-12">
                                        <hr>
                                    </div>
                                </div>
    
                            </td>
                            <td width="15%">Opposite Party</td>
                            <td width="35%">
                                <div class="col-sm-12 paddingless"
                                    *ngFor="let feOP of FetchExistingOppositeParty; let i=index ">
                                    <div class="col-sm-12">
                                        <b class="col-sm-5"> {{i+1}} )
                                        </b> <span class="col-sm-6">{{feOP.Name}}
                                        </span>
    
    
                                    </div>
                                    <div class="col-sm-12">
                                        <hr>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
                            <td width="15%">State</td>
                            <td width="35%">
                                <div class="col-sm-10">    
    
                                    <ng-select
                                      [items]="State"
                                      bindLabel="MainDescr"
                                      bindValue="hdID"
                                      formControlName="State"
                                      (change)="onStateSelect($event)"
                                      [clearable]="false"
                                      placeholder="Not Selected">
                                      <ng-option [value]="'0'">Not Selected</ng-option>
                                    </ng-select>
                                </div>
                            </td>
                            <td width="15%">City</td>
                            <td width="35%">
    
    
                                <ng-select
                                  [items]="City"
                                  bindLabel="MainDescr"
                                  bindValue="hdID"
                                  formControlName="City"
                                  (change)="onCitySelect($event)"
                                  [clearable]="false"
                                  placeholder="Not Selected">
                                  <ng-option [value]="'0'">Not Selected</ng-option>
                                </ng-select>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
                            <td width="15%">Category</td>
                            <td width="35%">
                                <div class="col-sm-10">
                                    <ng-select
                                      [items]="Category"
                                      bindLabel="MainDescr"
                                      bindValue="hdID"
                                      formControlName="Category"
                                      (change)="onCategorySelect($event)"
                                      [clearable]="false"
                                      placeholder="Not Selected">
                                      <ng-option [value]="'0'">Not Selected</ng-option>
                                    </ng-select>
    
                                </div>
                            </td>
                            <td width="15%">Sub Category</td>
                            <td width="35%">
                                <ng-select
                                  [items]="SubCategory"
                                  bindLabel="MainDescr"
                                  bindValue="hdID"
                                  formControlName="SubCategory"
                                  [clearable]="false"
                                  placeholder="Not Selected">
                                  <ng-option [value]="'0'">Not Selected</ng-option>
                                </ng-select>
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
                            <td width="15%">Final Order</td>
                            <td width="35%">
                                <div class="col-sm-10">
                                    <input type='file' formControlName="browseFiles" (change)="onSelectFile($event)"
                                        multiple>
                                </div>
                            </td>
                            <td width="15%">Amount</td>
                            <td width="35%">
                                <input type="number" class="form-control" formControlName="Amount" placeholder="Amount"
                                    required="required" />
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
                            <td width="15%">Decision <span style="color:red;">*</span></td>
                            <td width="35%">
                                <div class="col-sm-10">
                                    <ng-select
                                      [items]="[
                                        { label: 'Not Selected', value: '0' },
                                        { label: 'In Our Favour', value: '1' },
                                        { label: 'Against US', value: '2' }
                                      ]"
                                      bindLabel="label"
                                      bindValue="value"
                                      formControlName="Decision"
                                      [clearable]="false"
                                      multiple="true"
                                      placeholder="Not Selected">
                                    </ng-select>
                                </div>
                            </td>
    
                            <td width="15%">Time Period</td>
                            <td width="35%">
                                <div class="col-sm-12">
                                    <div class="col-sm-6">
                                        <mat-form-field class="fullwidth">
    
                                            <input matInput [min]="minDate" formControlName="DateofFinalvedictFromTime"
                                                [max]="maxDate" [matDatepicker]="picker" placeholder="Choose a date"
                                                class="">
    
                                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                            <mat-datepicker #picker></mat-datepicker>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-6">
                                        <mat-form-field class="fullwidth">
                                            <input matInput [min]="minDate" formControlName="DateofFinalvedictToTime"
                                                [max]="maxDate" [matDatepicker]="picker1" placeholder="Choose a date"
                                                class="">
    
                                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                            <mat-datepicker #picker1></mat-datepicker>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </td>
                        </tr>
    
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
                            <td width="15%">Judgements Implications</td>
                            <td width="35%">
                                <div class="col-sm-10">
                                    
                                    <ng-select
                                    [items]="dropdownListJudgements"
                                    bindLabel="MainDescr"
                                    bindValue="hdID"
                                    formControlName="JudgementsImplications"
                                    [multiple]="true"
                                    [closeOnSelect]="false"
                                    placeholder="Select Your Judgements Implications"
                                    (add)="onManagerDecisionSelectJudgements($event)">
                                    </ng-select>
                                </div>
                            </td>
    
                            <td width="15%">Remarks</td>
                            <td width="35%">
                                
                                    <textarea type="text" formControlName="Remarks"
                                        class="form-control TextareafullSize"></textarea>
                                
                            </td>
                        </tr>
                        <tr>
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
                            <td width="15%">Management Decision</td>
                            <td width="35%">
                                <div class="col-sm-10">

                                    <ng-select
                                    [items]="dropdownList"
                                    bindLabel="MainDescr"
                                    bindValue="hdID"
                                    formControlName="ManagementDecision"
                                    [multiple]="true"
                                    [closeOnSelect]="false"
                                    placeholder="Select Your Management Decision"
                                    (add)="onManagerDecisionSelect($event)"
                                    (remove)="onManagerDecisionDeSelect($event)">
                                    </ng-select>
    
    
                                </div>
                            </td>
    
                            <td width="15%">&nbsp;</td>
                            <td width="35%">
                                
    
                                <div *ngIf="this.RequestFromUploadFile=='7'">
                                    <table class="fullwidth LMtable">
                                        <tr>
                                            <th>S.No.</th>
        
                                            <th>Files</th>
        
                                        </tr>
                                        <tr style="border: lightgray solid 1px "
                                            *ngFor="let fsD of factsheetDetail; let i=index ">
                                            <td align="center">{{i+1}}</td>
        
                                            <td>
                                                <table>
                                                    <tr *ngFor="let fsDFile of fsD.attachment; let i=index">
                                                        <td><a
                                                                href={{DownloadURL}}{{fsDFile.DownloadPath}}>{{fsDFile.DisplayName}}</a>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </td>
                        </tr>
                    </table>
    
                   
    
                    <div *ngIf="this.PaymentofPenaltyRequestFrom == '1'">
                        <h4 style="    margin-left: 27px; margin-bottom: 18px;">Payment of Penalty</h4>
                        <div class="col-sm-12">
                            <div class="col-sm-2">
                                Amount
                            </div>
    
                            <div class="col-sm-3">
                                <input type="number" class="form-control" formControlName="PaymentAmount"
                                    placeholder="Amount" required="required" />
                            </div>
                            <div class="col-sm-2">
                                Responsible Person
                            </div>
                            <div class="col-sm-4">
    
                                    <ng-select
                                      [items]="PaymentResponsiblePerson"
                                      bindLabel="USERNAME"
                                      bindValue="ID"
                                      formControlName="PaymentResponsiblePerson"
                                      [clearable]="false"
                                      placeholder="Not Selected">
                                      <ng-option [value]="'0'">Not Selected</ng-option>
                                    </ng-select>
                            </div>
                        </div>
    
                        <div class="col-sm-12" style="margin-top: 12px;">
                            <div class="col-sm-2">
                                Payment to made in favour of
                            </div>
    
                            <div class="col-sm-3">
                                <input type="text" class="form-control" formControlName="Paymenttomadeinfavourof"
                                    placeholder="Payment to made in favour of" required="required" />
                            </div>
                            <div class="col-sm-2">
                                Remarks
                            </div>
    
                            <div class="col-sm-4">
                                <textarea type="text" formControlName="PaymentRemarks"
                                    class="form-control TextareafullSize"></textarea>
                            </div>
                        </div>
                        <div class="col-sm-12" style="margin-top: 12px;">
    
    
                            <div class="col-sm-2">
                                <br />
                                Time Period
                            </div>
                            <div class="col-sm-3">
                                <mat-form-field class="fullwidth">
    
                                    <input matInput [min]="minDate" formControlName="DateofFinalVedictPaymentFromTime"
                                        [max]="maxDate" [matDatepicker]="picker4" placeholder="Choose from date" class="">
    
                                    <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                                    <mat-datepicker #picker4></mat-datepicker>
                                </mat-form-field>
                            </div>
    
                            <div class="col-sm-2">
                                <mat-form-field class="fullwidth">
    
                                    <input matInput [min]="minDate" formControlName="DateofFinalVedictPaymentToTime"
                                        [max]="maxDate" [matDatepicker]="picker5" placeholder="Choose from date" class="">
    
                                    <mat-datepicker-toggle matSuffix [for]="picker5"></mat-datepicker-toggle>
                                    <mat-datepicker #picker5></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    
                    <div *ngIf="this.RecoveryofAmountRequestFrom == '2'">
                        <h4 style="margin-left: 27px; margin-bottom: 18px;">Recovery of Amount</h4>
    
                        <div class="col-sm-12">
                            <div class="col-sm-2">
                                Amount
                            </div>
    
                            <div class="col-sm-3">
                                <input type="number" class="form-control" formControlName="RecoverAmount"
                                    placeholder="Amount" required="required" />
                            </div>
    
    
                            <div class="col-sm-2">
                                Responsible Person
                            </div>
    
                            <div class="col-sm-4">
    
                                    <ng-select
                                      [items]="RecoveryResponsiblePerson"
                                      bindLabel="USERNAME"
                                      bindValue="ID"
                                      formControlName="RecoveryResponsiblePerson"
                                      [clearable]="false"
                                      placeholder="Not Selected">
                                      <ng-option [value]="'0'">Not Selected</ng-option>
                                    </ng-select>
                            </div>
                        </div>
    
                        <div class="col-sm-12" style="margin-top: 12px;">
                            <div class="col-sm-2">
                                <br />
                                Time Period
                            </div>
                            <div class="col-sm-3">
                                <mat-form-field class="fullwidth">
    
                                    <input matInput [min]="minDate" formControlName="DateofFinalVedictRecoveryFromTime"
                                        [max]="maxDate" [matDatepicker]="picker6" placeholder="Choose from date" class="">
    
                                    <mat-datepicker-toggle matSuffix [for]="picker6"></mat-datepicker-toggle>
                                    <mat-datepicker #picker6></mat-datepicker>
                                </mat-form-field>
                            </div>
    
                            <div class="col-sm-2">
                                <mat-form-field class="fullwidth">
    
                                    <input matInput [min]="minDate" formControlName="DateofFinalVedictRecoveryToTime"
                                        [max]="maxDate" [matDatepicker]="picker7" placeholder="Choose To date" class="">
    
                                    <mat-datepicker-toggle matSuffix [for]="picker7"></mat-datepicker-toggle>
                                    <mat-datepicker #picker7></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-sm-4">
                                Remarks
                                <textarea type="text" formControlName="RecoveryRemarks"
                                    class="form-control TextareafullSize"></textarea>
                            </div>
                        </div>
                    </div>
    
    
                    <div *ngIf="this.ComplianceofComplyRequestFrom == '3'">
                        <h4 style="margin-left: 27px; margin-bottom: 18px;">Comply with Compliane</h4>
    
                        <div class="col-sm-12">
                            <div class="col-sm-2">
                                Type of Compliance
                            </div>
    
                            <div class="col-sm-3">
                                <input type="text" class="form-control" formControlName="TypeofCompliance"
                                    placeholder="Type of Compliance" required="required" />
                            </div>
    
                            <div class="col-sm-2">
                                Responsible Person
                            </div>
    
                            <div class="col-sm-4">
    
                                    <ng-select
                                      [items]="ComplianceResponsiblePerson"
                                      bindLabel="USERNAME"
                                      bindValue="ID"
                                      formControlName="ComplianceResponsiblePerson"
                                      [clearable]="false"
                                      placeholder="Not Selected">
                                      <ng-option [value]="'0'">Not Selected</ng-option>
                                    </ng-select>
                            </div>
                        </div>
                        <div class="col-sm-12" style="margin-top: 12px;">
                            <div class="col-sm-2">
                                <br />
                                Time Period
                            </div>
                            <div class="col-sm-3">
                                <mat-form-field class="fullwidth">
    
                                    <input matInput [min]="minDate" formControlName="DateofFinalVedictComplianceFromTime"
                                        [max]="maxDate" [matDatepicker]="picker8" placeholder="Choose From date" class="">
    
                                    <mat-datepicker-toggle matSuffix [for]="picker8"></mat-datepicker-toggle>
                                    <mat-datepicker #picker8></mat-datepicker>
                                </mat-form-field>
                            </div>
    
                            <div class="col-sm-2">
                                <mat-form-field class="fullwidth">
    
                                    <input matInput [min]="minDate" formControlName="DateofFinalVedictComplianceToTime"
                                        [max]="maxDate" [matDatepicker]="picker9" placeholder="Choose To date" class="">
    
                                    <mat-datepicker-toggle matSuffix [for]="picker9"></mat-datepicker-toggle>
                                    <mat-datepicker #picker9></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-sm-4">
                                Remarks
                                <textarea type="text" formControlName="ComplianceRemarks"
                                    class="form-control TextareafullSize"></textarea>
                            </div>
                        </div>
                    </div>
    
    
                    <div class="col-sm-12 d-flex justify-content-center my-5" *ngIf="this.buttonSubmitFinalVerdict == '1'">
    
                        <input class="btn btn-primary " width="110px;" type="submit" id="submitwidth" name="submit"
                            value="Submit" ngmodel>
                    </div>
    
    
                    <div class="col-sm-12 d-flex justify-content-center my-5"  *ngIf="this.buttonSubmitFinalVerdict == '2'">
    
                        <input class="btn btn-primary"  type="submit" id="submitwidth" name="Update"
                            value="Update" ngmodel>
                    </div>
    
                </fieldset>
    
            </form>
        </div>
    
    
    
    </my-content>
    <my-content placeholder="main">

    </my-content> -->
}